import React from 'react';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import slotimg from "../../images/free.png";
import "./rawMaterial-master.css";
import Pagination from 'react-js-pagination';


const RawMaterial = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);
  const [ refundpopup,setrefundpopup ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  const [postLoading, setPostLoading] = useState(false); // Loading state

  const [DeleteId, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    stock_code: "",
    description: "",
    stock_category: "",
    stock_type: "",
    uom: "",
    unit_purchase_price: "",
    currency: "",
    primary_vendor: "",
    unit_selling_price: "",
  });

  
  const handleInputUpdateChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Submit form

const [remarks, setRemarks] = useState('');
const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});

console.log(formData)
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10); // Number of items per page
const [searchTerm, setSearchTerm] = useState('');

// Filtering tables based on search term
const filteredTables = tables.filter((item) => {
  return (
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.stock_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.stock_category.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.stock_type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.unit_purchase_price.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.primary_vendor.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.unit_selling_price.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.uom.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.currency.toLowerCase().includes(searchTerm.toLowerCase()) 

  );
});

// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
const totalItems = filteredTables.length;

const handleSearchInput = (event) => {
  setSearchTerm(event.target.value);
  setCurrentPage(1); // Reset to the first page when search changes
};

const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};
//change the role
  const handleCodeSelectChange = (selectedItem) => {
    console.log("selectedItem",selectedItem)
    const role = selectedItem.value
    setFormData({ ...formData, e_role: role });
  };

  const submit = async (e) => {
    e.preventDefault();
    const shop_id=localStorage.getItem('ShopId');
    const token=localStorage.getItem('Token');

    const payload = {
      shop_id: shop_id,
      name: formData.name,
      stock_code: formData.stock_code,
      description: formData.description,
      stock_category: formData.stock_category,
      stock_type: formData.stock_type,
      uom: formData.uom,
      unit_purchase_price: formData.unit_purchase_price,
      currency: formData.currency,
      primary_vendor: formData.primary_vendor,
      unit_selling_price: formData.unit_selling_price,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };

    try {
      const response = await axios.post(`${var_api}raw-material-master/post`, payload,{
        headers:{
          Authorization:`${token}`
        }
      });
      console.log("Response:", response.data);
      // alert("Raw material created successfully!");
      Swal.fire("Success", "Raw material  Created successfully!", "success");
      fetchTables();
      setFormData({}); // Reset form
      setCreate(false); // Close modal
    } catch (error) {
      Swal.fire("Error", `${error.response.data.message}`, "error");
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error creating data:", error);
      }
    } 
  };


//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};

const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};

    useEffect(() => {
        fetchTables();
        // fetchShops();
      }, []);


      const fetchTables = async (id) => {
        const token = localStorage.getItem('Token');
        setLoading(true);
        console.log(id)
        const shopId =localStorage.getItem('ShopId');
        try {
           const shop = localStorage.getItem('ShopId')
           const response = await axios.get(`${var_api}raw-material-master/get/${shopId}`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data.data;
          setTables(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
          setTables([])
        }
      };
      

      const fetchShops = async () => {
        try {
           const shop = localStorage.getItem('userId')
           const response = await axios.get(`${var_api}/api/shop/data/${shop}`);
           console.log("response",response)
          const user =response.data;
          setShops(user);
          setFormData(prevState => ({
            ...prevState,
            shops: user.map(shop => ({ shop_id: shop.id, shop_name: shop.shop_name, is_active: 0 }))
          }));
        } catch (error) {
          console.log(error);
        }
      };

      const shopCodeOptions = [
        { value: 0, label: 'All' },
        ...shops.map(shop => ({
          value: shop.id,
          label: shop.shop_name
        }))
      ];
      
      

     //search the transaction data
     const filteredSuppliers = tables && tables.filter((order) => {
      const searchLower = searchQuery.toLowerCase();
      return (
        (order.e_name && order.e_name.toString().toLowerCase().includes(searchLower)) ||
        (order.e_email && order.e_email.toString().toLowerCase().includes(searchLower))  ||
        (order.e_phone && order.e_phone.toString().toLowerCase().includes(searchLower))  ||
        (order.e_role && order.e_role.toString().toLowerCase().includes(searchLower)) 
      );
    });

//handle image change
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        console.log("files",file);
        setFormData({ ...formData, profile: file });
      };

//handle text field change
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value
  });
};


 // Function to handle checkbox change
 const handleCheckboxChange = (index) => {
  const updatedShops = [...formData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };

  setFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

     
 


    //reset the values
    const handleToReset = () => {
         // Reset the form fields individually
         setFormData({
          ...formData,
          e_name: " ", 
  e_email: "", 
  e_password:" ",
  e_phone:"",
  e_role:"",
  profile:null
      });
    }

    //Go to home page
    const handleButtonClick = () => {
      history.push('/AdminHome')
    }




      const update = async (e) => {
        e.preventDefault();
        try {
          const token = localStorage.getItem("Token"); // Replace with your token logic
          const response = await axios.put(
            `${var_api}raw-material-master/put/${formData.id}`, // Use the selected item's ID
            formData,
            {
              headers: {
                Authorization: token,
              },
            }
          );
          if (response.status === 200) {
            Swal.fire("success"," Raw Material Updated Successfully!","success")

            setIsEdit(false); // Close the modal
            fetchTables(); // Refresh the data
          }
        } catch (error) {
          Swal.fire("Error", `${error.response.data.message}`, "error");
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
        }
      };

      
      
      const cancel = async (e) => {
        setIsEdit(false);
        setFormData({}); 

      };
      const cancel2 = async (e) => {
        setCreate(false);
        setFormData({}); 

      };
      const handleEdit = (item) => {
        setFormData({
          name: item.name,
          id: item.id,

          stock_code: item.stock_code,
          description: item.description,
          stock_category: item.stock_category,
          stock_type: item.stock_type,
          uom: item.uom,
          unit_purchase_price: item.unit_purchase_price,
          currency: item.currency,
          primary_vendor: item.primary_vendor,
          unit_selling_price: item.unit_selling_price,
                });
        setIsEdit(true); // Open the edit modal
      };
      




    //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('Token');
      axios.delete(`${var_api}rawmaterial-master/delete/${DeleteId.id}`,{
        headers:{
          Authorization:`${token}`
        }
      }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchTables(); // Refresh the employee list
            setShow(false);
            Swal.fire("Success", "Raw Material removed successfully!", "success");
          } else if (response.status === 404) {
            console.error("Employee not found");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error deleting data:", error);
          }
          Swal.fire("Error", `${error.response.data.message}`, "error");
        });
    };


    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
      console.log("data",data)
      setUpdateFormData({
          id:data.id,
          e_name: data.e_name, 
          e_email: data.e_email, 
          e_password: data.e_password,
          e_phone: data.e_phone,
          e_role: data.e_role,
          profile: data.e_profile,
          shops: data.shops
      })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
      setFormData({}); 
    }

    const handlerefundpopup = () =>{
        setrefundpopup(true);
    }



//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};

//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile: file });
};


 // Function to handle update checkbox change
 const handleUpdateCheckboxChange = (index) => {
  const updatedShops = [...updateformData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };
  console.log("upd",updatedShops);

  setUpdateFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};

     //delete method for remove UOM
     const handleDeleteEmployeee = (id) => {
      setEmployeeD({id});
      setShow(true);
    };







    return(
      <>         <Layout>

      

            <div class="splitrefund">
          
            <div style={{border:"none", padding:"15px", width:"100%", height:"630px",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px", marginTop:"-15px"}}>    
    
    <div>
  
   
     <div class="row">
       <div class="col">
       <h4 className='ushe'>RAW MATERIAL MASTER</h4>
       </div>
       <div class="col">
       <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Raw Material</Button>{' '}
       <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
       </div>
     </div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll', marginTop:"5px" }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
  <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Item Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Stock Code</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Description</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Stock Category</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Stock Type</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Purchase Price</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Primary Vendor</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Selling Price</th>

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">UOM </th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Currency</th>

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
<tbody className="body-half-screen">
  {currentItems && currentItems.length > 0 ? (
    currentItems.map((item, index) => (
      <tr style={{ padding: "4px" }} key={index}>
        <th scope="row">{index + 1}</th>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.name}</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.stock_code}</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.description}</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.stock_category}</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.stock_type}</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.unit_purchase_price}</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.primary_vendor}</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.unit_selling_price}</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.uom}</td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.currency}</td>
        <td style={{ textAlign: "left" }}>
          <i
            className="bi bi-pencil-square"
            onClick={() => handleEdit(item)}
            style={{ fontSize: "20px", color: "grey" }}
          ></i>{" "}
          <i
            className="bi bi-trash"
            onClick={() => handleDeleteEmployeee(item.id)}
            style={{ fontSize: "21px", color: "rgb(175, 2, 2)" }}
          ></i>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td
        colSpan="12"
        style={{
          textAlign: "center",
          color: "grey",
          borderColor: "black",
        }}
      >
        No Data Available
      </td>
    </tr>
  )}
</tbody>

}
</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Raw Material 
          <span style={{color:"red",textTransform:"uppercase"}}> </span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Raw Material</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={update}>
        <div class="row">
            <div class="col">
              <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Item Name</label>
              <input type="text" class="form-control" placeholder="Enter Item Name" id="input1" value={formData.name}  name="name"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div className="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Stock Code</label>
            <input type="text" class="form-control" placeholder="Enter Stock Code" id="input1" value={formData.stock_code}  name="stock_code"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Description</label>
            <input type="text" class="form-control" placeholder="Enter Description" id="input1" value={formData.description}  name="description"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div class='col'>
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Stock Category</label>
            <input type="text" class="form-control" placeholder="Enter Stock Category" id="input1" value={formData.stock_category}  name="stock_category"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Stock Type</label>
            <input type="text" class="form-control" placeholder="Enter Stock Type" id="input1" value={formData.stock_type}  name="stock_type"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
          </div>
       <div class="col">
       <label
    htmlFor="slotSelect"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
   UOM
  </label>
  <input type="text" class="form-control" placeholder="Enter Unit Purchase Price" id="input1" value={formData.uom}  name="uom"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>

       </div> 
       </div>
         <br/>
         <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Default Unit Purchase Price</label>
            <input type="number" class="form-control" placeholder="Enter Unit Purchase Price" id="input1" value={formData.unit_purchase_price}  name="unit_purchase_price"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} min="0.1" step="0.1" required/>
          </div>
       <div class="col">
       <label
    htmlFor="currency"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
   Default UPP Currency
  </label>
  <input type="number" class="form-control" placeholder="Enter currency" id="input1" value={formData.currency}  name="currency"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>

       </div> 
       </div>
       <br/>
       <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Default UPP Primary Vendor</label>
            <input type="text" class="form-control" placeholder="Enter UPP Primary Vendor" id="input1" value={formData.primary_vendor}  name="primary_vendor"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
          </div>
          <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Default Unit Selling Price</label>
            <input type="number" class="form-control" placeholder="Enter Unit Selling Price" id="input1" value={formData.unit_selling_price} min="0.1" step="0.1" name="unit_selling_price"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
          </div>
       </div>
       <br/>

       <br/>
         <div class="text-center">
          
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}}>Update</button>
    
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>cancel()} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Raw Material</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={submit}>
        <div class="row">
            <div class="col">
              <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Item Name</label>
              <input type="text" class="form-control" placeholder="Enter Item Name" id="input1" value={formData.name}  name="name"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div className="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Stock Code</label>
            <input type="text" class="form-control" placeholder="Enter Stock Code" id="input1" value={formData.stock_code}  name="stock_code"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Description</label>
            <input type="text" class="form-control" placeholder="Enter Description" id="input1" value={formData.description}  name="description"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
            <div class='col'>
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Stock Category</label>
            <input type="text" class="form-control" placeholder="Enter Stock Category" id="input1" value={formData.stock_category}  name="stock_category"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Stock Type</label>
            <input type="text" class="form-control" placeholder="Enter Stock Type" id="input1" value={formData.stock_type}  name="stock_type"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
          </div>
       <div class="col">
       <label
    htmlFor="slotSelect"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
   UOM
  </label>
  <input type="text" class="form-control" placeholder="Enter Unit Purchase Price" id="input1" value={formData.uom}  name="uom"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>

       </div> 
       </div>
         <br/>
         <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Default Unit Purchase Price</label>
            <input type="number" class="form-control" placeholder="Enter Unit Purchase Price" id="input1" value={formData.unit_purchase_price}  min="0.1" step="0.1" name="unit_purchase_price"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
          </div>
       <div class="col">
       <label
    htmlFor="currency"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
   Default UPP Currency
  </label>
  <input type="text" class="form-control" placeholder="Enter currency" id="input1" value={formData.currency}  name="currency"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>

       </div> 
       </div>
       <br/>
       <div class="row">
            <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Default UPP Primary Vendor</label>
            <input type="text" class="form-control" placeholder="Enter UPP Primary Vendor" id="input1" value={formData.primary_vendor}  name="primary_vendor"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} required/>
          </div>
          <div class="col">
            <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Default Unit Selling Price</label>
            <input type="number" class="form-control" placeholder="Enter Unit Selling Price" id="input1" value={formData.unit_selling_price}  name="unit_selling_price"  onChange={handleInputUpdateChange}  style={{borderRadius:"12px"}} min="0.1" step="0.1" required/>
          </div>
       </div>
       <br/>

       <br/>
         <div class="text-center">
          
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}}>Create</button>
    
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>cancel2()} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal>

      <Modal
        show={refundpopup}
        onHide={()=>setrefundpopup(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Apply Refund</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" >
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Refund Date</label>
               <input type="date" class="form-control" id="floatingInput" placeholder="Select Date" name='Enter date' value={formData.e_name} onChange={handleInputChange}  style={{borderRadius:"15px",height:"50px"}} required/>
               </div>
          </div>
          <br/>
          <div class="row">
          <div className="col">
  <label
    htmlFor="slotSelect"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
    Method
  </label>
  <select
    className="form-control"
    id="slotSelect"
    name="e_slot"
    value={updateformData.e_slot}
    onChange={handleInputChange}
    style={{ borderRadius: "12px" }}
    required
  >
    <option value="">Select</option>
    <option value="slot1">Credit</option>
    <option value="slot2">Debit</option>
    <option value="slot3">Net Banking</option>
    {/* Add more options as needed */}
  </select>
</div>
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Amount{" "}</label>
            <input type="number" class="form-control" id="formFile" placeholder='Enter Amount' onChange={handleImageChange} name='profile'  style={{borderRadius:"15px",height:"50px"}} />
            </div>
          </div>
          <div class="row">
          <div className="col">
      <label htmlFor="description" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
        Refund Notes
      </label>
      <textarea
        id="description"
        className="form-control"
        value={remarks}
        onChange={setRemarks}
        placeholder="Enter a description..."
        rows="4"
        style={{ borderRadius: "15px", height: "100px", resize: "vertical" }} // Matches other input styles
        required
      />
    </div>
       </div>
         <br/>
         <div class="text-center">
     
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} >Apply</button>
       
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>setrefundpopup(false)} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 


            {/* </div> */}
       </Layout></>

        
    )
}

export default RawMaterial;